export default {
    strict: true,
    fields: {
        name: {
            type: "string",
        },
        email: {
            type: "string",
        },
        phoneNumber: {
            type: "string",
        },
        createdAt: {
            type: "date",
        },
    },
};
